var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menuItems.length > 0)?_c('div',{staticClass:"lg:h-full"},[_c('DesktopSidebar',{attrs:{"menu-items":_vm.menuItems,"footer-menu-items":_vm.footerMenuItems}}),_vm._v(" "),_c('MobileSidebar',{attrs:{"menu-items":_vm.menuItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }